import React from "react";
import styleClasses from "../../../components/ItemGrid/ItemGrid.module.scss";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Image, Tooltip, OverlayTrigger } from "react-bootstrap";
import { Tag } from "../../../models/Menu.model";
import { symbolDetails } from "./SymbolDetails";
import useCheckMobileScreen from "../../../hooks/useCheckMobileScreen";
import { useLocation } from "react-router";
import { useIsDesignV2 } from "../../../hooks/useIsDesignV2";

interface SymbolsProps {
  tags: Tag[];
}
const TagSymbol: React.FunctionComponent<SymbolsProps> = ({ tags }) => {

 const isThisMobile = useCheckMobileScreen();
 const location = useLocation();
 const isDesignV2 = useIsDesignV2()
  // Function to render tooltip according to provided class name respective to symbol
  const renderTooltip = (tag, styleClass) => {
    return (
      <Tooltip className={styleClass} id="tooltip-vegeterian">
        {tag.name}
      </Tooltip>
    );
  };

  // Function to return icon and class name according to symbol name
  const getSymbolDetail = (name: string) => {
    const lowerCaseName = name.toLowerCase();
    for(const keyword in symbolDetails){
      if(lowerCaseName.includes(keyword)){
        return  symbolDetails[keyword];
      }
    }
  };

  return (
    <span className={styleClasses.item_icon_wrap + isDesignV2 && styleClasses.item_icon_wrap_mobile_designv2 + " d-flex flex-wrap"}>
      {tags?.map((tag) => {
        const detail = getSymbolDetail(tag.name);
        if (!detail) return "";
        return (
          <OverlayTrigger
            key={tag.id}
            placement="bottom"
            delay={{ show: 250, hide: 400 }}
            overlay={renderTooltip(tag, detail.className)}
          >
            <Image src={detail.icon} className={`tooltip-icon ${isDesignV2 && "tooltip-icon_mobile_designv2"}`} alt="toolTip"/>
          </OverlayTrigger>
        );
      })}
    </span>
  );
};

export default TagSymbol;
